import {createRouter, createWebHistory} from 'vue-router'
import LandingPage from "@/views/LandingPage";
import SubmitOTP from "@/views/SubmitOTP";
import CreateUsername from "@/views/CreateUsername";
import GameSelection from "@/views/GameSelection";
import SubscribeUser from "@/views/SubscribeUser";
import HowToPlay from "@/views/HowToPlay";
import ContentBlock from "@/views/ContentBlock";
import store from "@/store";

const routes = [
    {
        path: '/',
        redirect: '/login',
    },
    {
        path: '/login',
        name: 'Login',
        component: LandingPage,
    },
    {
        path: '/otp',
        name: 'SubmitOTP',
        component: SubmitOTP,
        beforeEnter: routerGuard,
    },
    {
        path: '/subscribe',
        name: 'SubscribeUser',
        component: SubscribeUser,
        beforeEnter: routerGuard,
    },
    {
        path: '/create-username',
        name: 'CreateUsername',
        component: CreateUsername,
        beforeEnter: routerGuard,
    },
    {
        path: '/game-selection',
        name: 'GameSelection',
        component: GameSelection,
        beforeEnter: routerGuard,
    },
    {
        path: '/how-to-play',
        name: 'HowToPlay',
        component: HowToPlay,
        beforeEnter: routerGuard,
    },
    {
        path: '/content-block',
        name: 'ContentBlock',
        component: ContentBlock,
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

async function routerGuard(to, from, next) {
    let isAuthenticated = false;

    if (to.fullPath === '/otp') {
        const msisdn = localStorage.getItem('msisdn');
        store.commit('setMsisdn', msisdn);
        if (store.state.msisdn) {
            isAuthenticated = true;
        }
    }
    if (to.fullPath === '/game-selection') {
        const token = localStorage.getItem('token');
        if (token) store.commit('setToken', token);

        if (store.state.encryptedMsisdn || store.state.token || store.state.user) {
            isAuthenticated = true;
        }
    }
    if (to.fullPath === '/subscribe') {
        if (store.state.user && store.state.user.status !== 'Subscribed') {
            isAuthenticated = true;
        }
    }
    if (to.fullPath === '/create-username' || to.fullPath === '/how-to-play') {
        if (store.state.user || store.state.token) {
            isAuthenticated = true;
        }
    }
    if (isAuthenticated) {
        next();
    } else {
        next('/');
    }
}

router.beforeEach((to, from, next) => {
    next();
})

export default router
